import { defaultDateFormat } from "apps/visits/core/config/dates";
import dayjs from "dayjs";
import type { TFunction } from "i18next";
import * as yup from "yup";
import { parseYupDateString } from "../utils/yup";

export const getDateOfBirthSchema = (t: TFunction, dateFormat = defaultDateFormat) =>
  yup
    .date()
    .transform((_, val) => parseYupDateString(_, val, dateFormat))
    .typeError(t("COMMONS.ERRORS.INCORRECT_DATE"))
    .min(
      dayjs("1900-01-01").format(dateFormat),
      t("COMMONS.ERRORS.INCORRECT_DATE_MIN", { date: dayjs("1900-01-01").format(dateFormat) }),
    )
    .max(dayjs().format(dateFormat), t("COMMONS.ERRORS.INCORRECT_DATE_MAX", { date: dayjs().format(dateFormat) }));
